import React, { useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { HIGHLIGHTERS } from '../../lib/paper';
import { Tape } from '../paper';

/**
 * The Home "ask" box as a sticky note taped to the desk (mobile's AskSticky):
 * italic label, a plain ruled field, and an ink send dot.
 */
export const AskSticky: React.FC<{ onAsk: (q: string) => void }> = ({ onAsk }) => {
  const [query, setQuery] = useState('');
  const canSend = query.trim().length > 0;
  const submit = (): void => {
    const q = query.trim();
    if (!q) return;
    setQuery('');
    onAsk(q);
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
      className="relative mt-8 -rotate-[0.8deg] rounded-lg rounded-br-[1.75rem] border border-solid border-[rgba(107,82,0,0.18)] bg-hl-yellow px-4 pb-3 pt-5 shadow-[0_12px_40px_rgba(28,27,25,0.1)] md:px-6"
    >
      <Tape tone={HIGHLIGHTERS.coral} width={72} height={20} rotate={3} className="left-1/2 top-[-9px] -ml-9" />
      <label htmlFor="ask-sticky" className="block font-headline text-[1.0625rem] italic leading-6 text-hl-yellow-ink md:text-lg">
        Ask your notebook anything
      </label>
      <div className="mt-1 flex items-center gap-2 border-b-[1.5px] border-solid border-[rgba(107,82,0,0.2)]">
        <input
          id="ask-sticky"
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="What did I write about…"
          autoComplete="off"
          className="min-w-0 flex-1 border-none bg-transparent py-2.5 font-body text-[0.9375rem] text-on-surface outline-none placeholder:text-hl-yellow-ink"
        />
        <button
          type="submit"
          disabled={!canSend}
          aria-label="Ask"
          className={`mb-1.5 flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full border-none transition-[transform,background] duration-150 active:scale-[0.88] disabled:cursor-default ${
            canSend ? 'bg-primary text-on-primary' : 'bg-[rgba(107,82,0,0.12)] text-hl-yellow-ink'
          }`}
        >
          <ArrowUp size={18} />
        </button>
      </div>
    </form>
  );
};
